var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.368408 11.975C0.368408 18.4111 5.58592 23.6286 12.0221 23.6286C18.4582 23.6286 23.6757 18.4111 23.6757 11.975C23.6757 5.53886 18.4582 0.32135 12.0221 0.32135C5.58592 0.32135 0.368408 5.53887 0.368408 11.975Z",
    fill: "#D80917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7577 19.8333C11.7358 19.8333 11.7131 19.832 11.6913 19.8287C11.5113 19.8039 11.3602 19.6809 11.2996 19.5096L6.56471 6.09741C6.50455 5.92657 6.54439 5.73647 6.66809 5.60418C6.79179 5.47188 6.97955 5.41876 7.15325 5.46798L16.692 8.12814C16.7538 8.14532 16.8126 8.17501 16.8629 8.21537L18.6564 9.63985C18.8585 9.80001 18.9001 10.0904 18.7512 10.3003L12.154 19.6279C12.0631 19.7567 11.9153 19.8333 11.7577 19.8333ZM7.79153 6.65418L11.9027 18.3013L17.6926 10.1149L16.3363 9.03751L7.79153 6.65418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7586 19.8333C11.7407 19.8333 11.7235 19.8323 11.7055 19.8305C11.4391 19.8016 11.2464 19.562 11.275 19.2956L11.9891 12.6838C12.0175 12.4164 12.2651 12.2286 12.524 12.2534C12.7904 12.2823 12.9831 12.5219 12.9545 12.7883L12.2404 19.4C12.2138 19.6487 12.0034 19.8333 11.7586 19.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4719 13.2216C12.3487 13.2216 12.2253 13.1752 12.1305 13.0818C11.9399 12.893 11.938 12.5857 12.1266 12.3948L16.2162 8.25441C16.405 8.06379 16.7122 8.06196 16.9029 8.25024C17.0935 8.43905 17.0953 8.74634 16.9068 8.93722L12.8169 13.0773C12.7259 13.1697 12.6016 13.2217 12.4719 13.2216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4718 13.2216C12.2887 13.2216 12.1132 13.1172 12.0309 12.9396C11.9189 12.6964 12.0252 12.4076 12.2679 12.2951L18.1507 9.57943C18.3955 9.46693 18.6827 9.57318 18.7955 9.81693C18.9075 10.0602 18.8012 10.349 18.5585 10.4615L12.6757 13.1771C12.6117 13.2064 12.5422 13.2216 12.4718 13.2216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5418 13.306C12.3996 13.306 12.2593 13.2437 12.1634 13.1239L6.64391 6.23931C6.47594 6.03019 6.5098 5.72472 6.71943 5.55702C6.92803 5.39009 7.2348 5.42368 7.40172 5.63254L12.9202 12.5172C13.0882 12.7263 13.0548 13.0318 12.8452 13.1995C12.7592 13.2685 12.6521 13.3061 12.5418 13.306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr20);
export default __webpack_public_path__ + "static/media/tr20.6d54ac54768fb8d445d87bb269d68840.svg";
export { ForwardRef as ReactComponent };